import './App.css'
import ModelPage from './ModelPage'
import { Canvas } from 'react-three-fiber'
import { Suspense } from 'react'
import { Html, useGLTF } from '@react-three/drei'

// 모델 미리 로드 (중요)
useGLTF.preload('/mainboard.glb')

function App() {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <Canvas>
        <Suspense fallback={<Loading />}>
          <ModelPage
            url="mainboard.glb"
            image="mainboard_background.png"
            modelScale={0.7}
            modelPosition={[0, 0.1, 0]}
            cameraPosition={[-1, 0, 5.3]}
          />
        </Suspense>
      </Canvas>
    </div>
  )
}

// 로딩 스피너
function Loading() {
  return (
    <Html center>
      <div style={spinnerWrapperStyle}>
        <div style={spinnerStyle} />
        <div style={textStyle}>모델 불러오는 중...</div>
      </div>
    </Html>
  )
}

const spinnerWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.6)',
  padding: '1.5rem 2rem',
  borderRadius: '10px',
  minWidth: '200px',
  maxWidth: '90vw',
}

const spinnerStyle = {
  width: '40px',
  height: '40px',
  border: '5px solid #f3f3f3',
  borderTop: '5px solid #3498db',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  marginBottom: '10px',
}

const textStyle = {
  color: 'white',
  fontSize: '1.1rem',
  fontWeight: '500',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  wordBreak: 'keep-all',
}



// 애니메이션 등록
const styleSheet = document.styleSheets[0]
styleSheet.insertRule(`
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`, styleSheet.cssRules.length)

export default App
